import { escapeHtml } from "../utils/escapeHtml";
import type { Notification } from "../types/index";

export function renderNotificationBell(
  container: HTMLElement,
  notifications: Notification[],
  unreadCount: number,
): void {
  const badge = unreadCount > 0
    ? `<span class="notif-badge">${unreadCount > 9 ? "9+" : unreadCount}</span>`
    : "";

  const bellSvg = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>`;

  container.innerHTML = `
    <button id="notif-bell-btn" class="notif-bell" type="button" title="Notifications" aria-label="Notifications (${unreadCount} unread)">
      ${bellSvg}${badge}
    </button>
    <div id="notif-dropdown" class="notif-dropdown hidden">
      <div class="notif-header">
        <span>Notifications</span>
        ${unreadCount > 0 ? `<button id="notif-mark-all" class="btn btn-sm btn-ghost" type="button">Mark all read</button>` : ""}
      </div>
      <div class="notif-list">
        ${notifications.length === 0
          ? `<div class="notif-empty">No notifications yet.</div>`
          : notifications.slice(0, 20).map((n) => `
            <div class="notif-item ${n.read ? "" : "notif-unread"}" data-notif-id="${escapeHtml(n.id)}" data-notif-panel="${escapeHtml(n.linkPanel || "")}">
              <div class="notif-item-title">${escapeHtml(n.title)}</div>
              <div class="notif-item-body">${escapeHtml(n.body)}</div>
              <div class="notif-item-time">${new Date(n.createdAt).toLocaleString()}</div>
            </div>
          `).join("")
        }
      </div>
    </div>
  `;
}
